module.exports = __webpack_public_path__ + "img/766d789.png";